import api from "../../../../BasicComponent/Service/api";
import { ORGANIZATION_URL } from "../../../Utils/constService";

export const fetchOrganization = () => {
  return api.get(ORGANIZATION_URL);
};

export const postOrganization = (data) => {
  return api.post(ORGANIZATION_URL, data);
};

export const putOrganization = (organizationId, data) => {
  return api.put(`${ORGANIZATION_URL}/${organizationId}`, data);
};

export const deleteOrganization = (organizationId) => {
  return api.delete(`${ORGANIZATION_URL}/${organizationId}`);
};
